import React from 'react';
import { Box, BoxSection } from 'components/_new/Box';
import './StatsItem.scss';
import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';

type StatColorVariant = 'lpurplish' | 'purplish' | 'rose';

type ProgressBarProps = { current: number; variant?: StatColorVariant; disabled?: boolean };

const ProgressBar = ({ current, variant, disabled }: ProgressBarProps) => {
	const width = `${current}%`;
	return (
		<div
			className={classNames(
				'stats-progress',
				disabled
					? 'stats-progress-disabled'
					: {
							'stats-progress-rose': variant === 'rose',
							'stats-progress-purplish': variant === 'purplish',
							'stats-progress-lpurplish': variant === 'lpurplish',
					  }
			)}
		>
			<div className="stats-progress-bar" style={{ width }} />
		</div>
	);
};

type StatsProgressProps = StatsItemProps & {
	progressValue?: number;
	positivePercValue?: number;
	className?: string;
	disabled?: boolean;
};

export const StatsItemProgress = ({
	name,
	value,
	progressValue,
	positivePercValue,
	variant,
	className,
	disabled,
}: StatsProgressProps) => {
	const { t } = useTranslation();
	return (
		<Box
			variant="white-bordered"
			className={classNames(
				'stats-item',
				disabled
					? 'stats-item-disabled'
					: {
							'stats-item-rose': variant === 'rose',
							'stats-item-purplish': variant === 'purplish',
							'stats-item-lpurplish': variant === 'lpurplish',
					  },
				className
			)}
			slim
		>
			<BoxSection className="">
				<ProgressBar current={progressValue || Number(value) || 0} variant={variant} disabled={disabled} />
			</BoxSection>
			<BoxSection contentClassName="gap-1">
				<div className="flex flex-row gap-3 justify-items-center align-items-center">
					<div className="num">{value}</div>
					<div className="title">{name}</div>
				</div>
				{positivePercValue ? (
					<div className="perc">
						{t('programPanel.statistics.avgMenteeGoalsAchievementPositivePerc', {
							count: positivePercValue,
						})}
					</div>
				) : null}
			</BoxSection>
		</Box>
	);
};

type StatsItemProps = {
	name: string;
	value?: string | number | null;
	variant?: StatColorVariant;
	disabled?: boolean;
};

export const StatsItem = ({ name, value, variant, disabled }: StatsItemProps) => {
	return (
		<Box
			variant="white-bordered"
			className={classNames(
				'stats-item',
				disabled
					? 'stats-item-disabled'
					: {
							'stats-item-rose': variant === 'rose',
							'stats-item-purplish': variant === 'purplish',
							'stats-item-lpurplish': variant === 'lpurplish',
					  }
			)}
			slim
		>
			<BoxSection contentClassName="num">{value}</BoxSection>
			<BoxSection className="">{name}</BoxSection>
		</Box>
	);
};
